import SiteLayout from '@/components/feature/SiteLayout';
import Hero from './components/Hero';
import TrustPoints from './components/TrustPoints';
import LeadCategories from './components/LeadCategories';
import SubmitFlow from './components/SubmitFlow';
import EditorPrinciples from './components/EditorPrinciples';
import Testimonials from './components/Testimonials';
import HomeFaq from './components/HomeFaq';
import HomeCta from './components/HomeCta';
import { homeFaqs } from '@/mocks/home';

const faqSchema = {
  '@context': 'https://schema.org',
  '@type': 'FAQPage',
  mainEntity: homeFaqs.map((f) => ({
    '@type': 'Question',
    name: f.q,
    acceptedAnswer: { '@type': 'Answer', text: f.a },
  })),
};

const siteSchema = {
  '@context': 'https://schema.org',
  '@type': 'WebSite',
  name: '17吃瓜网',
  alternateName: '17吃瓜网投稿入口',
  url: 'https://gzruanke.cn/',
  inLanguage: 'zh-CN',
  description:
    '17吃瓜网提供娱乐与网络热点线索的投稿入口，支持匿名投稿、私信爆料与线索征集，并对投稿人身份严格保密。',
  publisher: {
    '@type': 'Organization',
    name: '17吃瓜网',
    description: '专注娱乐与网络热点线索征集、核实与内容整理的平台。',
  },
  potentialAction: {
    '@type': 'SearchAction',
    target: 'https://gzruanke.cn/guide?query={search_term_string}',
    'query-input': 'required name=search_term_string',
  },
};

export default function Home() {
  return (
    <SiteLayout>
      <title>17吃瓜网投稿入口 - 匿名投稿·私信爆料·线索征集全掌握</title>
      <meta
        name="description"
        content="手上有料想上瓜？进入17吃瓜网投稿入口，支持匿名投稿与私信爆料，也可通过线索征集通道把素材直接递到编辑手里，投稿人身份严格保密，36小时内初步核实。"
      />
      <meta name="keywords" content="17吃瓜网,投稿入口,匿名投稿,私信爆料,线索征集,爆料联系方式" />
      <meta name="robots" content="index,follow,max-image-preview:large" />
      <link rel="canonical" href="https://gzruanke.cn/" />

      <meta property="og:type" content="website" />
      <meta property="og:site_name" content="17吃瓜网" />
      <meta property="og:title" content="17吃瓜网投稿入口 - 匿名投稿·私信爆料·线索征集" />
      <meta
        property="og:description"
        content="支持匿名投稿与私信爆料的线索征集平台，直接进入投稿入口，把线索递到编辑手里。"
      />
      <meta property="og:url" content="https://gzruanke.cn/" />
      <meta property="og:locale" content="zh_CN" />

      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content="17吃瓜网投稿入口 - 匿名投稿·私信爆料·线索征集" />
      <meta
        name="twitter:description"
        content="进入17吃瓜网投稿入口，支持匿名投稿与私信爆料，线索征集通道全天开放。"
      />

      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(siteSchema) }} />
      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(faqSchema) }} />

      <Hero />
      <TrustPoints />
      <LeadCategories />
      <SubmitFlow />
      <EditorPrinciples />
      <Testimonials />
      <HomeFaq />
      <HomeCta />
    </SiteLayout>
  );
}